import Component from '../../classes/Component';
import {$events} from "../../helpers/events";
import variables from "../../variables";
import {apiHelper, getChoice, resetChoice} from "../../helpers/_utilities";
import {$dom} from "../../helpers/dom";

const {customEventNames, classNames} = variables;
const formId = 'js-conference-feedback';
const postSelectName = 'userPost';

export default function () {
    const $Page = this;

	return new Component({
		name: 'feedback',
		requiredTargets: '#'+formId,
		onInit() {
		    const {notify, formValidation} = $Page.components;

            this.handleFormSubmit = ({detail}) => {
                const {form, submitBtn} = detail;

                $dom.addClass(submitBtn, classNames.isLoading);
                apiHelper({
                    url: '/conference/send',
                    data: new FormData(form)
                })
                    .then(({status, message}) => {
                        notify.show({
                            description: message,
                            status: status ? 'success' : 'error'
                        });

                        if (status) {
                            form.reset();
                            formValidation.validator.reset(form);

                            const postSelectEl = form.elements[postSelectName];
                            if (postSelectEl) {
                                const postSelectChoice = getChoice(postSelectEl);
                                if (postSelectChoice)
                                    resetChoice(postSelectChoice, true);
                            }
                        }
                    })
                    .finally(() => $dom.removeClass(submitBtn, classNames.isLoading))
            }

		    $events.delegate
                .on(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
        },
		onDestroy() {
            $events.delegate
                .off(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
        }
	})
}
